/**
 * Odznaka z liczba na favikonie karty (Patryk 28.09.2026: "dzwonek z liczba na karcie,
 * odpowiadajacy liczbie na ikonce"). Rysuje oryginalny favicon.ico na canvasie i dokleja
 * czerwone kolko z liczba w prawym dolnym rogu, po czym podmienia href linku <link
 * id="app-favicon"> na wynikowy data URL. Bez zadnych uprawnien przegladarki - to zwykly obrazek.
 */

let baseImage: HTMLImageElement | null = null;
let baseImageLoading: Promise<HTMLImageElement> | null = null;
let lastCount: number | null = null;

function loadBaseImage(): Promise<HTMLImageElement> {
  if (baseImage) {
    return Promise.resolve(baseImage);
  }

  if (!baseImageLoading) {
    baseImageLoading = new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => { baseImage = img; resolve(img); };
      img.onerror = reject;
      img.src = 'favicon.ico';
    });
  }

  return baseImageLoading;
}

export async function setFaviconBadge(count: number): Promise<void> {
  if (count === lastCount) {
    return;
  }

  lastCount = count;

  const link = document.getElementById('app-favicon') as HTMLLinkElement | null;

  if (!link) {
    return;
  }

  if (count <= 0) {
    link.href = 'favicon.ico';
    return;
  }

  try {
    const img = await loadBaseImage();
    const size = 64;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      return;
    }

    ctx.clearRect(0, 0, size, size);
    ctx.drawImage(img, 0, 0, size, size);

    const radius = size * 0.32;
    const cx = size - radius - 2;
    const cy = size - radius - 2;

    ctx.beginPath();
    ctx.arc(cx, cy, radius, 0, Math.PI * 2);
    ctx.fillStyle = '#e53935';
    ctx.fill();
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#ffffff';
    ctx.stroke();

    ctx.fillStyle = '#ffffff';
    ctx.font = `bold ${count > 9 ? radius * 1.05 : radius * 1.3}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(count > 99 ? '99+' : String(count), cx, cy + 1);

    link.href = canvas.toDataURL('image/png');
  } catch {
    // Brak ikony bazowej albo canvas zablokowany (np. bardzo stara przegladarka) -
    // po prostu zostawiamy zwykly favicon, to tylko kosmetyczny dodatek.
  }
}
